<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row align-items-center mb-25">
                <div class="col-lg-8">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex align-items-center user-member__title">
                            <h4 class="text-capitalize fw-500 breadcrumb-title mb-0">
                                Statistik Pengguna
                            </h4>
                        </div>
                        <p class="text-muted mb-0 mt-2">
                            Monitoring pesan keluar per user — tanggal
                            <strong>{{ formattedDate }}</strong>
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 mt-3 mt-lg-0">
                    <div class="d-flex align-items-end justify-content-lg-end gap-2">
                        <div class="flex-grow-1">
                            <label class="small text-muted mb-1 d-block">Filter tanggal</label>
                            <v-date-picker class="inline-block h-full w-100" v-model="filter.date" mode="date"
                                :show-current="true">
                                <template v-slot="{ inputValue, togglePopover }">
                                    <input @focus="togglePopover()" :value="inputValue"
                                        class="form-control" placeholder="Pilih tanggal" readonly />
                                </template>
                            </v-date-picker>
                        </div>
                        <button type="button" class="btn btn-outline-primary" @click="refreshTable"
                            :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            Refresh
                        </button>
                    </div>
                </div>
            </div>

            <div class="row mb-30">
                <div class="col-md-3 col-sm-6 mb-20 mb-md-0">
                    <div class="stat-card stat-card--success">
                        <div class="stat-card__label">Total Sukses</div>
                        <div class="stat-card__value">{{ formatNum(summary.message_sent) }}</div>
                        <div class="stat-card__hint">Pesan terkirim (semua user)</div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-20 mb-md-0">
                    <div class="stat-card stat-card--warning">
                        <div class="stat-card__label">Total Pending</div>
                        <div class="stat-card__value">{{ formatNum(summary.message_pending) }}</div>
                        <div class="stat-card__hint">Menunggu antrian</div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-20 mb-md-0">
                    <div class="stat-card stat-card--danger">
                        <div class="stat-card__label">Total Gagal</div>
                        <div class="stat-card__value">{{ formatNum(summary.message_failed) }}</div>
                        <div class="stat-card__hint">Pesan gagal kirim</div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="stat-card stat-card--info">
                        <div class="stat-card__label">Pesan Masuk</div>
                        <div class="stat-card__value">{{ formatNum(summary.incoming_message) }}</div>
                        <div class="stat-card__hint">{{ formatNum(summary.total_users) }} user tercatat</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <StatisticsTable ref="statsTable" :date="filter.date" @summary="onSummary"
                            @loading="loading = $event" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatisticsTable from "@/components/tables/Statistics.vue";
    import moment from 'moment'

    export default {
        components: {
            StatisticsTable,
        },
        data() {
            return {
                filter: {
                    date: moment().format("YYYY-MM-DD"),
                },
                summary: {
                    message_sent: 0,
                    message_pending: 0,
                    message_failed: 0,
                    incoming_message: 0,
                    total_users: 0,
                },
                loading: false,
            };
        },
        computed: {
            formattedDate() {
                return moment(this.filter.date).format("DD MMMM YYYY");
            },
        },
        methods: {
            formatNum(n) {
                return Number(n || 0).toLocaleString("id-ID");
            },
            onSummary(summary) {
                this.summary = Object.assign({}, this.summary, summary || {});
            },
            refreshTable() {
                if (this.$refs.statsTable) {
                    this.$refs.statsTable.loadItems();
                }
            },
        },
    };
</script>

<style scoped>
.stat-card {
    border-radius: 12px;
    padding: 20px 22px;
    color: #fff;
    min-height: 110px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
.stat-card__label {
    font-size: 13px;
    opacity: 0.92;
    font-weight: 500;
}
.stat-card__value {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    margin: 6px 0;
}
.stat-card__hint {
    font-size: 12px;
    opacity: 0.85;
}
.stat-card--success { background: linear-gradient(135deg, #20c997, #12a87a); }
.stat-card--warning { background: linear-gradient(135deg, #ffc107, #e0a800); color: #212529; }
.stat-card--danger  { background: linear-gradient(135deg, #dc3545, #b02a37); }
.stat-card--info    { background: linear-gradient(135deg, #17a2b8, #117a8b); }
.gap-2 > * + * { margin-left: 8px; }
</style>
